import type { TransactionFlag } from '@shared/transactions-types';

import type { TransactionPredicate } from './types';

export const hasFlag =
    (...requiredFlags: TransactionFlag[]): TransactionPredicate =>
    ({ flags: transactionFlags }) =>
        Boolean(transactionFlags) && requiredFlags.some((flag) => transactionFlags.includes(flag));
